export interface CancelledMidTrialState {
  subscriptionTrialEnd: string | null;
  cancelAtPeriodEnd: boolean;
}

export function cancelledMidTrial(
  state: CancelledMidTrialState,
  now: Date = new Date()
): boolean {
  if (!state.subscriptionTrialEnd) return false;
  const trialEnd = new Date(state.subscriptionTrialEnd);
  if (Number.isNaN(trialEnd.getTime()) || trialEnd <= now) return false;
  return state.cancelAtPeriodEnd === true;
}
